import type { Vehicle } from '@otw/models'

/** Active (not sold) inventory VINs, uppercased — used to mark lead trucks already in inventory. */
export const buildActiveInventoryVinSet = (
  vehicles: Vehicle[] | undefined | null,
): Set<string> => {
  const set = new Set<string>()
  for (const vehicle of vehicles ?? []) {
    const status = vehicle.status?.toLowerCase() ?? ''
    if (status === 'sold' || status === 'sold elsewhere') continue
    const vin = vehicle.vin?.trim().toUpperCase()
    if (vin) set.add(vin)
  }
  return set
}

export const isVinInActiveInventory = (
  vin: string | null | undefined,
  activeVinSet: Set<string>,
): boolean => {
  const normalized = vin?.trim().toUpperCase()
  return Boolean(normalized && activeVinSet.has(normalized))
}
